export default __webpack_public_path__ + "static/media/Group 86.b40e7e35.png";